'use client'

import { AppLink } from '@/shared/lib/router'

import type { UserGroup } from '@/features/groups/types/groups'
import { useOptimizedRecords } from '@/shared/hooks/useOptimizedQuery'
import { cn } from '@/shared/lib/utils'
import { Button } from '@/shared/ui/Button'
import { Card, CardBody, CardHeader, CardTitle } from '@/shared/ui/Card'
import { Page } from '@/shared/ui/Page'

export function GroupsListPage() {
  const {
    records: groups,
    isLoading,
    isEmpty
  } = useOptimizedRecords<UserGroup>({
    path: '/user/groups'
  })

  return (
    <Page variant="default">
      <Card variant="default" className="max-w-2xl mx-auto">
        <CardHeader>
          <CardTitle>Meus grupos</CardTitle>
        </CardHeader>
        <CardBody>
          <div className="flex justify-end mb-4">
            <Button as={AppLink} href="/grupos/entrar" size="sm">
              Entrar com código
            </Button>
          </div>
          {isLoading && (
            <p className="rounded-2xl border border-dashed border-[#E0D7FF] bg-white/80 px-4 py-6 text-center text-sm text-[#6B6883]">
              Carregando...
            </p>
          )}
          {!isLoading && isEmpty && (
            <p className="rounded-2xl border border-dashed border-[#E0D7FF] bg-white/80 px-4 py-6 text-center text-sm text-[#6B6883]">
              Você ainda não está em nenhum grupo.
            </p>
          )}
          {!isLoading && groups.length > 0 && (
            <ul className="space-y-2">
              {groups.map(g => (
                <li key={g.id}>
                  <AppLink
                    href={`/ranking?tab=group&group=${g.id}`}
                    className={cn(
                      'flex w-full items-center justify-between rounded-xl px-4 py-3 text-left transition-all duration-100',
                      'bg-white bg-[linear-gradient(360deg,_#EAEEFF_-12.43%,_#BAC4F0_143.3%)]',
                      'shadow-[0_4px_0_-1px_#6A81DB,inset_0_3px_0_0_rgba(255,255,255,0.25)]',
                      'hover:-translate-y-px hover:shadow-[0_5px_0_-1px_#6A81DB,inset_0_3px_0_0_rgba(255,255,255,0.25)]',
                      'active:translate-y-px active:shadow-[inset_0_3px_0_0_rgba(255,255,255,0.25)]'
                    )}
                  >
                    <span className="font-semibold text-[#1F1C2B]">{g.name}</span>
                    {g.members_count != null && (
                      <span className="text-sm text-[#7F7FAD]">
                        {g.members_count} membros
                      </span>
                    )}
                  </AppLink>
                </li>
              ))}
            </ul>
          )}
        </CardBody>
      </Card>
    </Page>
  )
}
